import {ReactNode} from "react";
import {FilterProps, filterTypeOptions} from "../tableTypes";
import TableDateSlider from "../filters/TableDateSlider";
import TableDropdownSelector from "../filters/TableDropdownSelector";
import "./table-filter-item.css";
import {BigInput} from "../../forms/bigInput/BigInput";
import TableInput from "../filters/TableInput";

interface TableFilterItemProps extends FilterProps{

}

interface TableFilterItemLayoutProps {
    title: string;
    type: filterTypeOptions;
    children: ReactNode | ReactNode[];
}

const TableFilterItemLayout = ({ title, type, children }: TableFilterItemLayoutProps) => {
    return (
        <div className={`filter-section ${type}`}>
            <div className="filter-title">{title}<span></span></div>
            {children}
        </div>
    )
}

const TableFilterItem = ({ name, type, min, max, from, to, filterKey }: TableFilterItemProps) => {
    return (
        <TableFilterItemLayout title={name} type={type}>
            {type === filterTypeOptions.date && min && max && from && to ? <TableDateSlider type={type} filterKey={filterKey} from={from} to={to} min={min as Date} max={max as Date} /> : null}
            {type === filterTypeOptions.textToId || type === filterTypeOptions.textToKey ? <TableDropdownSelector type={type} filterKey={filterKey} /> : null}
            {type === filterTypeOptions.text ? <TableInput filterKey={filterKey} /> : null}
        </TableFilterItemLayout>
    );
}

export default TableFilterItem;